import {
	IonLabel,
	IonDatetime,
	IonDatetimeButton,
	IonModal,
	IonItem
} from "@ionic/react";

const Date = ({ id, label, value, onChange, showLabel = true }: any) => {
	return (
		<IonItem fill="outline" lines="none">
			{showLabel && label?.length > 0 && <IonLabel>{label}</IonLabel>}
			<IonDatetimeButton datetime={id}></IonDatetimeButton>
			<IonModal keepContentsMounted={true}>
				<IonDatetime
					presentation="date"
					id={id}
					showDefaultButtons={true}
					value={value}
					onIonChange={onChange}
					style={{ color: "black" }}
				>
					<span slot="title">{label}</span>
				</IonDatetime>
			</IonModal>
		</IonItem>
	);
};

export default Date;
